/* eslint-disable @typescript-eslint/default-param-last */
import produce, { Draft } from 'immer';
import {
  SET_API_CACHE,
  CLEAR_API_CACHE_BY_PREFIX,
  CLEAR_ALL_API_CACHE,
  ApiCacheEntry,
} from '../actions/apiCacheAction';
import { ApiCacheCustomAction, ApiCacheState } from '../types';

const initialState: ApiCacheState = {
  entries: {},
};

const apiCacheReducer = (
  state = initialState,
  action: ApiCacheCustomAction,
): ApiCacheState => {
  switch (action.type) {
    case SET_API_CACHE: {
      return produce(state, (draft: Draft<ApiCacheState>) => {
        const { key, entry } = action.payload as { key: string; entry: ApiCacheEntry };
        draft.entries[key] = entry;
      });
    }

    case CLEAR_API_CACHE_BY_PREFIX: {
      return produce(state, (draft: Draft<ApiCacheState>) => {
        const { prefix } = action.payload as { prefix: string };
        Object.keys(draft.entries).forEach((key) => {
          if (key.startsWith(prefix)) {
            delete draft.entries[key];
          }
        });
      });
    }

    case CLEAR_ALL_API_CACHE: {
      return produce(state, (draft: Draft<ApiCacheState>) => {
        draft.entries = {};
      });
    }

    default: {
      return state;
    }
  }
};

export default apiCacheReducer;
